import {message} from "antd";
import {useEffect, useState} from "react";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {consumeFormSnapshot} from "./form-snapshot";

export function useOAuthCalendarResume<T>(): T | null {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const justConnected = searchParams.get("calendarConnected") === "1";

  const [snapshot] = useState<T | null>(() =>
    justConnected ? consumeFormSnapshot<T>(location.pathname) : null
  );

  useEffect(() => {
    if (!justConnected) {
      return;
    }
    message.success("Google Calendar connected — continuing where you left off.");
    const next = new URLSearchParams(searchParams);
    next.delete("calendarConnected");
    navigate({pathname: location.pathname, search: next.toString()}, {replace: true});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return snapshot;
}
